import { render, staticRenderFns } from "./CheckboxSelect.vue?vue&type=template&id=04ddcf50&scoped=true&"
import script from "./CheckboxSelect.vue?vue&type=script&lang=js&"
export * from "./CheckboxSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ddcf50",
  null
  
)

export default component.exports